/* =========================================================
   Lesca theme — global JavaScript
   Vanilla JS, no dependencies. Kept intentionally small.
   ========================================================= */
(function () {
  "use strict";

  /* ---- Mobile menu toggle ---- */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-menu-toggle]");
    if (toggle) {
      var nav = document.querySelector("[data-mobile-nav]");
      if (nav) nav.classList.toggle("is-open");
    }
  });

  /* ---- Quantity steppers ---- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qty]");
    if (!btn) return;
    var input = btn.parentNode.querySelector("input");
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += btn.dataset.qty === "up" ? 1 : -1;
    input.value = Math.max(1, val);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---- Product gallery: swap main image from thumbnails ---- */
  document.addEventListener("click", function (e) {
    var thumb = e.target.closest("[data-gallery-thumb]");
    if (!thumb) return;
    var main = document.querySelector("[data-gallery-main]");
    if (main) main.src = thumb.dataset.full || thumb.src;
  });

  /* ---- AJAX add to cart ---- */
  function updateCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? "" : "none";
    });
  }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-product-form]");
    if (!form) return;
    if (form.dataset.ajax !== "true") return; // fall back to normal submit
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var original = button ? button.textContent : "";
    if (button) { button.disabled = true; button.textContent = "Adding…"; }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch("/cart.js").then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (window._lescaRefreshDrawer) window._lescaRefreshDrawer(true);
        if (button) { button.textContent = "Added ✓"; }
        setTimeout(function () {
          if (button) { button.disabled = false; button.textContent = original; }
        }, 1500);
      })
      .catch(function () {
        if (button) { button.disabled = false; button.textContent = original; }
        form.submit();
      });
  });

  /* ---- Variant selection: sync hidden id + price ---- */
  document.addEventListener("change", function (e) {
    var select = e.target.closest("[data-variant-select]");
    if (!select) return;
    var form = select.closest("[data-product-form]");
    if (!form) return;
    var jsonEl = form.querySelector("[data-variant-json]");
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];

    // Collect selected options
    var selects = form.querySelectorAll("[data-variant-select]");
    var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });

    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === chosen[i]; });
    });

    var idField = form.querySelector('[name="id"]');
    var priceEl = document.querySelector("[data-product-price]");
    var button = form.querySelector('[type="submit"]');

    if (match) {
      if (idField) idField.value = match.id;
      if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available ? (button.dataset.label || "Add to cart") : "Sold out";
      }
    }
  });

  /* ---- Sticky header: scrolled state + optional hide on scroll down ---- */
  function initStickyHeader() {
    var header = document.querySelector("[data-header]");
    if (!header) return;
    var wrapper = header.parentElement;
    var threshold = parseInt(header.getAttribute("data-scroll-threshold"), 10) || 80;
    var behavior = header.getAttribute("data-sticky-behavior") || "always";
    var lastY = window.scrollY;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      // Scrolled state drives the color swap and scrolled border width.
      header.classList.toggle("header--scrolled", y > threshold);
      if (behavior === "scroll_up" && wrapper) {
        // Hide when moving down past the threshold; reappear on any upward
        // scroll. Small jitter (<2px) is ignored to avoid flicker.
        if (y > threshold && y > lastY + 2) {
          wrapper.classList.add("header-wrapper--hidden");
        } else if (y < lastY - 2 || y <= threshold) {
          wrapper.classList.remove("header-wrapper--hidden");
        }
      }
      lastY = y;
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    // Avoid stacking listeners if re-initialised in the theme editor.
    window.removeEventListener("scroll", header._lescaScroll || function () {});
    header._lescaScroll = onScroll;
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
  }

  /* ---- Parallax on scroll ---- */
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initParallax() {
    if (reduceMotion) return;
    // Parallax applies to the fixed site-background layers only.
    var bgLayers = Array.prototype.slice.call(document.querySelectorAll("[data-bg-parallax]"));
    if (!bgLayers.length) return;
    var ticking = false;

    function update() {
      var vh = window.innerHeight;
      bgLayers.forEach(function (layer) {
        var lspeed = parseFloat(layer.getAttribute("data-bg-parallax")) || 0.5;
        var leffect = layer.getAttribute("data-bg-effect") || "drift";
        var lt = "";
        if (leffect === "drift" || leffect === "drift_zoom") {
          var loff = window.scrollY * lspeed * 0.15;
          if (layer.getAttribute("data-bg-clamp") === "1") {
            var lmax = vh * 0.10;
            if (loff > lmax) loff = lmax;
          }
          lt = "translate3d(0," + (-loff).toFixed(1) + "px,0)";
        }
        if (leffect === "zoom" || leffect === "drift_zoom") {
          var lscale = 1 + Math.min(window.scrollY * lspeed * 0.0002, 0.3);
          lt += (lt ? " " : "") + "scale(" + lscale.toFixed(4) + ")";
        }
        layer.style.transform = lt || "none";
      });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }

    window.removeEventListener("scroll", initParallax._handler || function () {});
    window.removeEventListener("resize", initParallax._handler || function () {});
    initParallax._handler = onScroll;
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    update();
  }

  function initReveal() {
    var root = document.documentElement;
    if (root.getAttribute("data-scroll-reveal") !== "true") return;
    if (!("IntersectionObserver" in window)) return; // unsupported: leave visible
    var main = document.getElementById("MainContent");
    if (!main) return;

    // The inline head script already added .reveal-ready before paint; ensure
    // it's present (belt and braces) so the CSS gate is active.
    root.classList.add("reveal-ready");

    var selector = ".banner, .media-text, .rich-text, .grid > *, .section > .text-center, .newsletter__form";
    var targets = Array.prototype.slice.call(main.querySelectorAll(selector))
      .filter(function (el) { return !el.hasAttribute("data-reveal"); });
    if (!targets.length) return;

    var reduceMotionReveal = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // Gentle stagger for items sharing a grid.
    main.querySelectorAll(".grid").forEach(function (grid) {
      Array.prototype.slice.call(grid.children).forEach(function (child, i) {
        child.style.transitionDelay = (Math.min(i, 8) * 60) + "ms";
      });
    });

    if (reduceMotionReveal) {
      targets.forEach(function (el) { el.setAttribute("data-reveal", ""); el.classList.add("is-visible"); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Bidirectional: reveal on entry, reset on exit, so elements animate
        // again whether you scroll down or back up.
        entry.target.classList.toggle("is-visible", entry.isIntersecting);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });

    targets.forEach(function (el) {
      el.setAttribute("data-reveal", "");
      io.observe(el);
    });
  }

  /* ---- Slideshow: fade rotation with arrows, dots, autoplay ---- */
  function initSlideshows() {
    Array.prototype.slice.call(document.querySelectorAll("[data-slideshow]")).forEach(function (s) {
      if (s._lescaSlides) return;
      var slides = s.querySelectorAll(".slideshow__slide");
      if (slides.length < 2) return;
      s._lescaSlides = true;
      var dots = s.querySelectorAll("[data-slide-dot]");
      var index = 0;
      var delay = parseInt(s.getAttribute("data-autoplay"), 10) || 0;
      var timer = null;

      function go(n) {
        index = (n + slides.length) % slides.length;
        slides.forEach(function (sl, k) { sl.classList.toggle("is-active", k === index); });
        dots.forEach(function (d, k) { d.classList.toggle("is-active", k === index); });
      }
      function play() {
        if (delay && !reduceMotion) timer = setInterval(function () { go(index + 1); }, delay);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      var prev = s.querySelector("[data-slide-prev]");
      var next = s.querySelector("[data-slide-next]");
      if (prev) prev.addEventListener("click", function () { stop(); go(index - 1); play(); });
      if (next) next.addEventListener("click", function () { stop(); go(index + 1); play(); });
      dots.forEach(function (d, k) {
        d.addEventListener("click", function () { stop(); go(k); play(); });
      });
      s.addEventListener("mouseenter", stop);
      s.addEventListener("mouseleave", function () { stop(); play(); });
      play();
    });
  }

  /* ---- Countdown timers ---- */
  function initCountdowns() {
    Array.prototype.slice.call(document.querySelectorAll("[data-countdown]")).forEach(function (el) {
      if (el._lescaCd) return;
      var target = Date.parse(el.getAttribute("data-countdown"));
      if (isNaN(target)) return;
      el._lescaCd = true;
      var d = el.querySelector("[data-cd-d]"), h = el.querySelector("[data-cd-h]"),
          m = el.querySelector("[data-cd-m]"), s = el.querySelector("[data-cd-s]");
      function pad(n) { return n < 10 ? "0" + n : "" + n; }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          el.classList.add("countdown--expired");
          el.textContent = el.getAttribute("data-expired-text") || "Ended";
          clearInterval(el._lescaCdTimer);
          return;
        }
        var secs = Math.floor(diff / 1000);
        if (d) d.textContent = Math.floor(secs / 86400);
        if (h) h.textContent = pad(Math.floor(secs % 86400 / 3600));
        if (m) m.textContent = pad(Math.floor(secs % 3600 / 60));
        if (s) s.textContent = pad(secs % 60);
      }
      tick();
      el._lescaCdTimer = setInterval(tick, 1000);
    });
  }

  /* ---- Cart drawer ---- */
  function drawerEl() { return document.querySelector("[data-cart-drawer]"); }
  function openDrawer() {
    var d = drawerEl(); if (!d) return;
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    document.body.classList.add("drawer-open");
  }
  function closeDrawer() {
    var d = drawerEl(); if (!d) return;
    d.classList.remove("is-open");
    d.setAttribute("aria-hidden", "true");
    document.body.classList.remove("drawer-open");
  }
  function refreshDrawer(open) {
    var wrap = document.getElementById("shopify-section-cart-drawer");
    if (!wrap) return;
    fetch(window.location.pathname + "?sections=cart-drawer")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var wasOpen = drawerEl() && drawerEl().classList.contains("is-open");
        wrap.innerHTML = data["cart-drawer"];
        if (wasOpen || open) openDrawer();
      })
      .catch(function () {});
  }
  window._lescaRefreshDrawer = refreshDrawer;

  function changeLine(line, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        refreshDrawer(true);
      })
      .catch(function () {});
  }

  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-cart-toggle]");
    if (toggle && drawerEl()) { e.preventDefault(); openDrawer(); return; }

    if (e.target.closest("[data-drawer-close]")) { closeDrawer(); return; }

    var qty = e.target.closest("[data-drawer-qty]");
    if (qty) {
      var holder = qty.closest(".cart-drawer__qty");
      var current = parseInt(holder.querySelector("[data-line-qty]").textContent, 10) || 0;
      changeLine(qty.getAttribute("data-line"), Math.max(0, current + parseInt(qty.getAttribute("data-drawer-qty"), 10)));
      return;
    }

    var rem = e.target.closest("[data-drawer-remove]");
    if (rem) { changeLine(rem.getAttribute("data-line"), 0); return; }

    /* Quick add from product cards */
    var qa = e.target.closest("[data-quick-add]");
    if (qa) {
      e.preventDefault();
      e.stopPropagation();
      var originalQa = qa.textContent;
      qa.disabled = true; qa.textContent = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: parseInt(qa.getAttribute("data-variant-id"), 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch("/cart.js").then(function (r) { return r.json(); }); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          qa.textContent = "Added ✓";
          if (drawerEl()) refreshDrawer(true);
          setTimeout(function () { qa.disabled = false; qa.textContent = originalQa; }, 1500);
        })
        .catch(function () { qa.disabled = false; qa.textContent = originalQa; });
      return;
    }

    /* Predictive search open/close */
    var st = e.target.closest("[data-search-toggle]");
    if (st) {
      var overlay = document.querySelector("[data-search-overlay]");
      if (overlay) {
        e.preventDefault();
        overlay.classList.add("is-open");
        overlay.setAttribute("aria-hidden", "false");
        var input = overlay.querySelector("[data-search-input]");
        if (input) setTimeout(function () { input.focus(); }, 60);
      }
      return;
    }
    if (e.target.closest("[data-search-close]")) {
      var ov = document.querySelector("[data-search-overlay]");
      if (ov) { ov.classList.remove("is-open"); ov.setAttribute("aria-hidden", "true"); }
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    closeDrawer();
    var ov = document.querySelector("[data-search-overlay]");
    if (ov) { ov.classList.remove("is-open"); ov.setAttribute("aria-hidden", "true"); }
  });

  /* ---- Predictive search fetching ---- */
  var searchTimer = null;
  document.addEventListener("input", function (e) {
    var input = e.target.closest("[data-search-input]");
    if (!input) return;
    var results = document.querySelector("[data-search-results]");
    if (!results) return;
    clearTimeout(searchTimer);
    var q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ""; return; }
    searchTimer = setTimeout(function () {
      fetch("/search/suggest?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=8&section_id=predictive-search")
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          var inner = tmp.querySelector(".predictive__results");
          results.innerHTML = inner ? inner.outerHTML : "";
        })
        .catch(function () {});
    }, 300);
  });

  function initScrollEffects() {
    initStickyHeader();
    initParallax();
    initReveal();
    initSlideshows();
    initCountdowns();
  }

  initScrollEffects();

  /* Re-initialise when sections are added/edited in the theme editor. */
  document.addEventListener("shopify:section:load", initScrollEffects);
  document.addEventListener("shopify:section:unload", initScrollEffects);
})();
